import Script from 'next/script';

export default function GoogleTagScripts({ googleTag }) {
    if (!googleTag) return null;

    if (googleTag.startsWith('G-') || googleTag.startsWith('UA-')) {
        return (
            <>
                <Script
                    async
                    src={`https://www.googletagmanager.com/gtag/js?id=${googleTag}`}
                />
                <Script id="analytics-init" strategy="afterInteractive">
                    {`
                        window.dataLayer = window.dataLayer || [];
                        function gtag(){dataLayer.push(arguments);}
                        gtag('js', new Date());
                        gtag('config', '${googleTag}');
                    `}
                </Script>
            </>
        );
    }

    if (googleTag.startsWith('AW-')) {
        return (
            <>
                <Script
                    async
                    src={`https://www.googletagmanager.com/gtag/js?id=${googleTag}`}
                />
                <Script id="ads-init" strategy="afterInteractive">
                    {`
                        window.dataLayer = window.dataLayer || [];
                        function gtag(){dataLayer.push(arguments);}
                        gtag('js', new Date());
                        gtag('config', '${googleTag}');
                    `}
                </Script>
            </>
        );
    }

    if (googleTag.startsWith('GTM-')) {
        return (
            <Script id="gtm-init" strategy="afterInteractive">
                {`
                    (function(w,d,s,l,i){
                        w[l]=w[l]||[];
                        w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
                        var f=d.getElementsByTagName(s)[0],
                            j=d.createElement(s),
                            dl=l!='dataLayer'?'&l='+l:'';
                        j.async=true;
                        j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
                        f.parentNode.insertBefore(j,f);
                    })(window,document,'script','dataLayer','${googleTag}');
                `}
            </Script>
        );
    }

    return null;
}
